import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  API,
  TablePlaylists,
  NavigationHelper,
  GlobalActions,
  viAdd,
  withRouter,
} from 'vibeguide';
import SubNavigation from '../../Header/SubNavigation';
import PlaylistSidebar from './Sidebar/PlaylistSidebar';
import './PlaylistsContainer.scss';

class PlaylistsContainer extends PureComponent {
  componentDidMount() {
    const qs = NavigationHelper.getParams() || {};
    const isNew = qs.type === 'new';
    const isView = qs.playlistId && qs.type !== 'new';

    if (isNew || isView) {
      setTimeout(() => {
        this.sidebar(qs.type, qs.playlistId);
      }, 1500);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: {
        search,
      },
    } = this.props;

    const {
      location: {
        search: prevSearch,
      },
    } = prevProps;

    if (search !== prevSearch) {
      const qs = NavigationHelper.getParams();

      if (qs.playlistId || qs.type === 'new') {
        this.sidebar(qs.type, qs.playlistId);
      }
    }
  }

  /**
   * When the sidebar is closed
   */
  onCloseSidebar = () => {
    const {
      history,
    } = this.props;

    const url = NavigationHelper.updateParams({
      playlistId: null,
      type: null,
    }, {
      keepPage: true,
    });

    history(url);
  };

  sidebar = (type, playlistId = null) => {
    const {
      setPanel,
    } = this.props;

    setPanel({
      show: true,
      backdrop: type === 'new',
      children: (
        <PlaylistSidebar
          playlistId={playlistId}
          isNew={type === 'new'}
          isDuplicate={type === 'new' && playlistId !== null}
        />
      ),
      onClose: this.onCloseSidebar,
    });
  };

  render() {
    return (
      <div className="PlaylistsContainer">
        <SubNavigation
          title="Playlists"
          buttons={[
            {
              text: 'New Playlist',
              icon: viAdd,
              color: 'primary',
              url: NavigationHelper.updateParams({
                type: 'new',
              }),
              userCan: [
                'playlist.create',
              ],
            },
          ]}
        />

        <TablePlaylists
          columns={[
            '.',
            'Name',
            'Description',
            'Company',
            'Songs',
            'Duration',
            'Avg. Song',
            'Genre',
            'Tags',
            '...',
          ]}
          fetch={API.Playlist.list}
          defaultSortBy={{
            label: 'Name',
            attr: 'name',
            direction: 'asc',
          }}
          paginator
          paginatorProps={{
            label: 'Playlists',
            urlPaging: true,
            urlFilters: true,
          }}
          toggle
          toggleProps={{
            label: 'Show Archived Playlists',
            tooltip: true,
          }}
          bulk
          bulkProps={{
            edit: false,
            add: false,
            block: false,
            remove: false,
            archive: true,
          }}
          rowLink={{
            playlistId: '_id',
          }}
          menuItems={[
            { name: 'Archive', userCan: 'playlist.delete' },
          ]}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default withRouter(connect(null, mapDispatchToProps)(PlaylistsContainer));
